import { GoodItem } from "./GoodItem";

function GoodsList(props) {
  const { goods = [], addToBasket = Function.prototype } = props;
  return (
    <>
      {!goods.length ? (
          <h3>Nothing here</h3>
        ) : (
        <ul className='goods'>
          {goods.map(item => (
            <li>
              <GoodItem
                key={`${item.mainId}-${item.offerId}`}
                good={item}
                addToBasket={addToBasket}
              />
            </li>
          ))}
        </ul>
        )
      }
    </>
  )
}

export { GoodsList };
